export default function px2rem() {
  let preFontSize, rootHtml, deviceWidth, deviceHeight
  if (!isMobile()) {
    rootHtml = document.documentElement
    deviceHeight = rootHtml.clientHeight
    rootHtml.style.fontSize = deviceHeight / (1080 / 100) + 'px'
    preFontSize = deviceHeight / (1080 / 100) + 'px'
    sessionStorage.setItem('preFontSize', preFontSize)
  } else {
    if (window.orientation === 180 || window.orientation === 0) {
      rootHtml = document.documentElement
      deviceWidth = rootHtml.clientWidth
      rootHtml.style.fontSize = deviceWidth / (1080 / 100) + 'px'
      preFontSize = deviceWidth / (1080 / 100) + 'px'
      sessionStorage.setItem('preFontSize', preFontSize)
      // rootHtml = document.documentElement
      // deviceHeight = rootHtml.clientHeight
      // rootHtml.style.fontSize = deviceHeight / (1920 / 100) + 'px'
      // preFontSize = deviceHeight / (1920 / 100) + 'px'
      // sessionStorage.setItem('preFontSize', preFontSize)
    } else {
      rootHtml = document.documentElement
      deviceWidth = rootHtml.clientWidth
      rootHtml.style.fontSize = deviceWidth / (2468 / 100) + 'px'
      preFontSize = deviceWidth / (2468 / 100) + 'px'
      sessionStorage.setItem('preFontSize', preFontSize)
    }

  }
}

function isMobile() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "Windows CE", "BlackBerry");
  var flag = false;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = true; break; }
  }
  let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
  if (!flag && isiPad) {
    flag = true
  }
  return flag;
};

window.onresize = function () {
  px2rem();
};